import * as yup from "yup";

import {ObjectWithAnyProps} from "@globals/types/utilityTypes";

import {phoneValidationSchema} from "@components/forms/validations/phoneValidationSchema";
import {validateFormValues} from "@components/forms/validations/validateFormValues";

export const FIELDS_LENGTH = {
  email: {
    max: 50,
  },
  first_name: {
    max: 30,
  },
  last_name: {
    max: 30,
  },
  phone_number: {
    max: 30,
  },
  password: {
    min: 8,
  },
};

const inviteValidationSchema = yup.object({
  first_name: yup
    .string()
    .max(
      FIELDS_LENGTH.first_name.max,
      `Maximum length is ${FIELDS_LENGTH.first_name.max}`
    )
    .required("Required"),
  last_name: yup
    .string()
    .max(
      FIELDS_LENGTH.last_name.max,
      `Maximum length is ${FIELDS_LENGTH.last_name.max}`
    )
    .required("Required"),
  phone_number: phoneValidationSchema,
  password: yup
    .string()
    .min(
      FIELDS_LENGTH.password.min,
      `Minimum password length is ${FIELDS_LENGTH.password.min}`
    )
    .required("Required"),
  confirmedPassword: yup
    .string()
    .required("Required")
    .oneOf([yup.ref("password"), null], "Passwords do not match"),
});

const matValidationSchema = yup
  .object({
    email: yup
      .string()
      .email("Invalid email address")
      .max(
        FIELDS_LENGTH.email.max,
        `Maximum length is ${FIELDS_LENGTH.first_name.max}`
      )
      .required("Required"),
    delivery_location_id: yup.string().nullable().required("Required"),
  })
  .concat(inviteValidationSchema);

export type InviteFormValues = yup.InferType<typeof inviteValidationSchema>;
export type MatFormValues = yup.InferType<typeof matValidationSchema>;

type validateReturn = (
  values: ObjectWithAnyProps
) => Promise<Record<string, never> | undefined>;

export const validate = (isWelcomeMatFlow: boolean): validateReturn => {
  return validateFormValues(
    isWelcomeMatFlow ? matValidationSchema : inviteValidationSchema
  );
};
